<label class="CeCheckbox-label">
    <input
        type="checkbox"
        [attr.id]="id ? id : null"
        [checked]="checked"
        [disabled]="disabled || readOnly()"
        class="CeCheckbox-input"
        [attr.aria-checked]="mixed ? 'mixed' : null"
        [attr.aria-describedby]="checkboxId + '-helper' + ' ' + checkboxId + '-error'"
        [attr.aria-invalid]="hasError"
        (click)="onCheckboxClick()"
        (checkboxValueChanged)="onCheckboxInteractionEvent($event)"
    />
    @if (label === '') {
        <span class="u-text-truncate">
            <ng-content></ng-content>
        </span>
    } @else {
        <span class="u-text-truncate" [innerHTML]="label | safeHtmlPipe"></span>
    }
    @if (suffixIcon()) {
        <ce-icon class="CeCheckbox-suffixIcon" [svgIcon]="suffixIcon()!" ce-icon-sm [attr.aria-hidden]="true" />
    }
</label>

@if (hasError && errorMessage) {
    <div class="CeCheckbox-label--error" [id]="checkboxId + '-error'" aria-live="polite">
        <ng-content select="[ce-error-message]"></ng-content>
    </div>
}
@if (!hasError && helperText) {
    <div class="CeCheckbox-label--helper-text" [id]="checkboxId + '-helper'">
        <ng-content select="[ce-checkbox-helper-text]"></ng-content>
    </div>
}
